import { UserActivityFeature } from '@datum-group/datum-map/lib/types';
import { MouseController } from '.';
import {
  IUserLayerRecord,
  IUserLayerRecordProperties,
} from '../../API/resources/userLayer';
import { SingleWindow } from '../Window';

export class UserLayerCardMouseControllerLink {
  constructor(
    private _mouseController: MouseController,
    private _card: SingleWindow<IUserLayerRecordProperties>,
  ) {}

  bind = () => {
    this._mouseController.on('left_click', this._handler);

    return this.unbind;
  };

  unbind = () => {
    this._mouseController.un('left_click', this._handler);
  };

  private _handler = (targetData: UserActivityFeature) => {
    const [, feature] = targetData;

    if (this._isUserLayerCard(feature)) {
      this._card.open(feature.properties);

      return;
    }
  };

  private _isUserLayerCard = (
    value: GeoJSON.Feature<GeoJSON.Geometry | null>,
  ): value is IUserLayerRecord => {
    if (value.id === undefined || !Number.isInteger(+value.id)) return false;

    const { properties } = value;

    if (!properties) return false;

    const hasUserLayerProps =
      'title' in properties &&
      'description' in properties &&
      'category' in properties &&
      'is_checked' in properties &&
      'is_archived' in properties &&
      'created' in properties &&
      'date_published' in properties;

    return hasUserLayerProps;
  };
}
